import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ProductCoursesResponse } from 'src/entities/ProductCourse.entity';

export const PRODUCT_COURSES_QUERY_KEY = 'product-courses';

const fetchProductCourses = async (
  startOn: string,
  endOn: string,
  shipperNames: string[],
): Promise<ProductCoursesResponse> => {
  const query = new URLSearchParams();
  query.set('start_on', startOn);
  query.set('end_on', endOn);
  shipperNames.forEach((name) => query.append('shipper_names[]', name));
  const res = await axios.get<ProductCoursesResponse>(`/api/v5/reports/product_courses?${query.toString()}`);
  return res.data;
};

type Params = { startOn: string; endOn: string; shipperNames: string[] };

export const useProductCoursesQuery = ({ startOn, endOn, shipperNames }: Params) =>
  useQuery({
    queryKey: [PRODUCT_COURSES_QUERY_KEY, startOn, endOn, shipperNames],
    queryFn: () => fetchProductCourses(startOn, endOn, shipperNames),
    enabled: Boolean(startOn) && Boolean(endOn) && shipperNames.length > 0,
    staleTime: Infinity
  });
